import TwentyPercentOff from './20_off.svg';
import Accessories from './accessories.svg';
import AgnosticVenue from './agnostic_venue.svg';
import AirplaneHoneymoon from './airplane_honeymoon.svg';
import Alterations from './alterations.svg';
import Badge from './badge.svg';
import Baking from './baking.svg';
import Band from './band.svg';
import BandsDj from './bands_dj.svg';
import BeachChill from './beach_chill.svg';
import Biplane from './biplane.svg';
import Bouquet from './bouquet.svg';
import BrideGroom from './bride_groom.svg';
import BrokenHeart from './broken_heart.svg';
import Butterflies from './butterflies.svg';
import CakeSlice from './cake_slice.svg';
import Calendar from './calendar.svg';
import Camera from './camera.svg';
import Camping from './camping.svg';
import CashFunds from './cash_funds.svg';
import Cardholder from './cardholder.svg';
import Celebratory1 from './celebratory_1.svg';
import Celebratory2 from './celebratory_2.svg';
import ChampagneCheers from './champagne_cheers.svg';
import ChampagneChill from './champagne_chill.svg';
import ChampagneGlasses from './champagne_glasses.svg';
import ChampagnePop from './champagne_pop.svg';
import CharityDonation from './charity_donation.svg';
import ChildcareServices from './childcare_services.svg';
import Clock from './clock.svg';
import Cooking from './cooking.svg';
import Couch1 from './couch_1.svg';
import Couch2 from './couch_2.svg';
import Couples1 from './couples_1.svg';
import Couples2 from './couples_2.svg';
import DateNight from './date_night.svg';
import Decisive from './decisive.svg';
import DecorInspiration from './decor_inspiration.svg';
import DigitalRsvp from './digital_rsvp.svg';
import DJ from './dj.svg';
import Easygoing1 from './easygoing_1.svg';
import Easygoing2 from './easygoing_2.svg';
import EiffelTower from './eiffel_tower.svg';
import Emotions from './emotions.svg';
import ExpertAdvice from './expert_advice.svg';
import FAQ from './faq.svg';
import FashionBeauty from './fashion_beauty.svg';
import FeelingExcited from './feeling_excited.svg';
import FeelingNothing from './feeling_nothing.svg';
import FeelingStressed from './feeling_stressed.svg';
import FemaleCouple from './female_couple.svg';
import FinishLine1 from './finish_line_1.svg';
import FinishLine2 from './finish_line_2.svg';
import Fireworks from './fireworks.svg';
import FiveStarApp from './five_star_app.svg';
import Flag from './flag.svg';
import FlowerVase from './flower_vase.svg';
import FreeShipping from './free_shipping.svg';
import Gift1 from './gift_1.svg';
import Gift2 from './gift_2.svg';
import GiftCardA from './gift_card_a.svg';
import GiftPile1 from './gift_pile_1.svg';
import GiftPile2 from './gift_pile_2.svg';
import GiftPile3 from './gift_pile_3.svg';
import GiftTracker from './gift_tracker.svg';
import GiftsFavors from './gifts_favors.svg';
import GreatAuntMillie from './great_aunt_millie.svg';
import GroomAccessories from './groom_accessories.svg';
import GroupGifting from './group_gifting.svg';
import GuestAddressing from './guest_addressing.svg';
import GuestBook from './guest_book.svg';
import GuestList from './guest_list.svg';
import HairMakeup from './hair_makeup.svg';
import HeartArrow from './heart_arrow.svg';
import HolidayCards from './holiday_cards.svg';
import HoneymoonFund from './honeymoon_fund.svg';
import Hotel from './hotel.svg';
import HotelKey from './hotel_key.svg';
import Invitations from './invitations.svg';
import IPad from './i_pad.svg';
import JustMarriedCar from './just_married_car.svg';
import LightBulb from './light_bulb.svg';
import LightBulb2 from './light_bulb_2.svg';
import Lively1 from './lively_1.svg';
import Lively2 from './lively_2.svg';
import Location from './location.svg';
import LoveBirds from './love_birds.svg';
import LowestCashFundFee from './lowest_cash_fund_fee.svg';
import Luggage from './luggage.svg';
import LuxuriousAndChic from './luxurious_and_chic.svg';
import Magnet from './magnet.svg';
import MaleCouple from './male_couple.svg';
import Megaphone from './megaphone.svg';
import MessageBird from './message_bird.svg';
import Mixer from './mixer.svg';
import NewlywedLifeA from './newlywed_life_a.svg';
import NewlywedLifeB from './newlywed_life_b.svg';
import Overwhelmed from './overwhelmed.svg';
import Palette from './personalization.svg';
import Passport from './passport.svg';
import PasswordProtection from './password_protection.svg';
import PhysicalRsvp from './physical_rsvp.svg';
import PlaceSetting from './place_setting.svg';
import PlaneTickets from './plane_tickets.svg';
import Postcard from './postcard.svg';
import PreWeddingFun from './pre_wedding_fun.svg';
import PriceMatching from './price_matching.svg';
import Pumped from './pumped.svg';
import PuppyFund from './puppy_fund.svg';
import ReadyToParty from './ready_to_party.svg';
import Registry from './registry.svg';
import RegistryAdvisor from './registry_advisor.svg';
import RegistryChecklist from './registry_checklist.svg';
import RelaxedCasual from './relaxed_casual.svg';
import RelaxedCasual2 from './relaxed_casual_2.svg';
import ReturnsExchanges from './returns_exchanges.svg';
import RingBox from './ring_box.svg';
import SeatingChart from './seating_chart.svg';
import Serene from './serene.svg';
import ServiceStaff from './service_staff.svg';
import Store from './store.svg';
import Suitcase from './suitcase.svg';
import SunnyDays from './sunny_days.svg';
import ThankYouNote from './thank_you_note.svg';
import ThankYouNoteManager from './thank_you_note_manager.svg';
import TotallyWowed from './totally_wowed.svg';
import TotallyWowed2 from './totally_wowed_2.svg';
import TotallyWowed3 from './totally_wowed_3.svg';
import TripOfALifetime from './trip_of_a_lifetime.svg';
import Trophy from './trophy.svg';
import TropicalDrink from './tropical_drink.svg';
import Veils from './veils.svg';
import VeilsAccessories from './veils_accessories.svg';
import Video from './video.svg';
import WarmCozy from './warm_cozy.svg';
import WarmCozy2 from './warm_cozy_2.svg';
import WeddingCake from './wedding_cake.svg';
import WeddingChecklist from './wedding_checklist.svg';
import WeddingGuests from './wedding_guests.svg';
import WeddingParty from './wedding_party.svg';
import WeddingPlanningBook from './wedding_planning_book.svg';
import WeddingRings from './wedding_rings.svg';
import WeddingShower from './wedding_shower.svg';
import WeddingWebsites from './wedding_websites.svg';
import WorshipVenue from './worship_venue.svg';

const SvgIcons = {
  TwentyPercentOff,
  Accessories,
  AgnosticVenue,
  AirplaneHoneymoon,
  Alterations,
  Badge,
  Baking,
  Band,
  BandsDj,
  BeachChill,
  Biplane,
  Bouquet,
  BrideGroom,
  BrokenHeart,
  Butterflies,
  CakeSlice,
  Calendar,
  Camera,
  Camping,
  Cardholder,
  CashFunds,
  Celebratory1,
  Celebratory2,
  ChampagneCheers,
  ChampagneChill,
  ChampagneGlasses,
  ChampagnePop,
  CharityDonation,
  ChildcareServices,
  Clock,
  Cooking,
  Couch1,
  Couch2,
  Couples1,
  Couples2,
  DateNight,
  Decisive,
  DecorInspiration,
  DigitalRsvp,
  DJ,
  Easygoing1,
  Easygoing2,
  EiffelTower,
  Emotions,
  ExpertAdvice,
  FAQ,
  FashionBeauty,
  FeelingExcited,
  FeelingNothing,
  FeelingStressed,
  FemaleCouple,
  FinishLine1,
  FinishLine2,
  Fireworks,
  FiveStarApp,
  Flag,
  FlowerVase,
  FreeShipping,
  Gift1,
  Gift2,
  GiftCardA,
  GiftPile1,
  GiftPile2,
  GiftPile3,
  GiftTracker,
  GiftsFavors,
  GreatAuntMillie,
  GroomAccessories,
  GroupGifting,
  GuestAddressing,
  GuestBook,
  GuestList,
  HairMakeup,
  HeartArrow,
  HolidayCards,
  HoneymoonFund,
  Hotel,
  HotelKey,
  Invitations,
  IPad,
  JustMarriedCar,
  LightBulb,
  LightBulb2,
  Lively1,
  Lively2,
  Location,
  LoveBirds,
  LowestCashFundFee,
  Luggage,
  LuxuriousAndChic,
  Magnet,
  MaleCouple,
  Megaphone,
  MessageBird,
  Mixer,
  NewlywedLifeA,
  NewlywedLifeB,
  Overwhelmed,
  Palette,
  Passport,
  PasswordProtection,
  PhysicalRsvp,
  PlaceSetting,
  PlaneTickets,
  Postcard,
  PreWeddingFun,
  PriceMatching,
  Pumped,
  PuppyFund,
  ReadyToParty,
  Registry,
  RegistryAdvisor,
  RegistryChecklist,
  RelaxedCasual,
  RelaxedCasual2,
  ReturnsExchanges,
  RingBox,
  SeatingChart,
  Serene,
  ServiceStaff,
  Store,
  Suitcase,
  SunnyDays,
  ThankYouNote,
  ThankYouNoteManager,
  TotallyWowed,
  TotallyWowed2,
  TotallyWowed3,
  TripOfALifetime,
  Trophy,
  TropicalDrink,
  Veils,
  VeilsAccessories,
  Video,
  WarmCozy,
  WarmCozy2,
  WeddingCake,
  WeddingChecklist,
  WeddingGuests,
  WeddingParty,
  WeddingPlanningBook,
  WeddingRings,
  WeddingShower,
  WeddingWebsites,
  WorshipVenue,
};

export {
  TwentyPercentOff,
  Accessories,
  AgnosticVenue,
  AirplaneHoneymoon,
  Alterations,
  Badge,
  Baking,
  Band,
  BandsDj,
  BeachChill,
  Biplane,
  Bouquet,
  BrideGroom,
  BrokenHeart,
  Butterflies,
  CakeSlice,
  Calendar,
  Camera,
  Camping,
  Cardholder,
  CashFunds,
  Celebratory1,
  Celebratory2,
  ChampagneCheers,
  ChampagneChill,
  ChampagneGlasses,
  ChampagnePop,
  CharityDonation,
  ChildcareServices,
  Clock,
  Cooking,
  Couch1,
  Couch2,
  Couples1,
  Couples2,
  DateNight,
  Decisive,
  DecorInspiration,
  DigitalRsvp,
  DJ,
  Easygoing1,
  Easygoing2,
  EiffelTower,
  Emotions,
  ExpertAdvice,
  FAQ,
  FashionBeauty,
  FeelingExcited,
  FeelingNothing,
  FeelingStressed,
  FemaleCouple,
  FinishLine1,
  FinishLine2,
  Fireworks,
  FiveStarApp,
  Flag,
  FlowerVase,
  FreeShipping,
  Gift1,
  Gift2,
  GiftCardA,
  GiftPile1,
  GiftPile2,
  GiftPile3,
  GiftTracker,
  GiftsFavors,
  GreatAuntMillie,
  GroomAccessories,
  GroupGifting,
  GuestAddressing,
  GuestBook,
  GuestList,
  HairMakeup,
  HeartArrow,
  HolidayCards,
  HoneymoonFund,
  Hotel,
  HotelKey,
  Invitations,
  IPad,
  JustMarriedCar,
  LightBulb,
  LightBulb2,
  Lively1,
  Lively2,
  Location,
  LoveBirds,
  LowestCashFundFee,
  Luggage,
  LuxuriousAndChic,
  Magnet,
  MaleCouple,
  Megaphone,
  MessageBird,
  Mixer,
  NewlywedLifeA,
  NewlywedLifeB,
  Overwhelmed,
  Palette,
  Passport,
  PasswordProtection,
  PhysicalRsvp,
  PlaceSetting,
  PlaneTickets,
  Postcard,
  PreWeddingFun,
  PriceMatching,
  Pumped,
  PuppyFund,
  ReadyToParty,
  Registry,
  RegistryAdvisor,
  RegistryChecklist,
  RelaxedCasual,
  RelaxedCasual2,
  ReturnsExchanges,
  RingBox,
  SeatingChart,
  Serene,
  ServiceStaff,
  Store,
  Suitcase,
  SunnyDays,
  ThankYouNote,
  ThankYouNoteManager,
  TotallyWowed,
  TotallyWowed2,
  TotallyWowed3,
  TripOfALifetime,
  Trophy,
  TropicalDrink,
  Veils,
  VeilsAccessories,
  Video,
  WarmCozy,
  WarmCozy2,
  WeddingCake,
  WeddingChecklist,
  WeddingGuests,
  WeddingParty,
  WeddingPlanningBook,
  WeddingRings,
  WeddingShower,
  WeddingWebsites,
  WorshipVenue,
  SvgIcons,
};

export default SvgIcons;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/index.js
// module id = 487
// module chunks = 51